<template>
    <div :class="['base-swich pointer', { checked }]">
        <input type="checkbox" class="pointer" v-model="checked">
        <div class="track"></div>
        <div class="thumb"></div>
    </div>
</template>

<script>
export default {
    name: "BaseSwich",
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checked: false
        }
    },
    watch: {
        value(val) {
            this.checked = val
        },
        checked(val) {
            this.$emit("input", val)
        }
    }
}
</script>

<style scoped>

.base-swich {
    position: relative;
    width: 32px;
    height: 20px;
}

input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    user-select: none;
    z-index: 1;
}

.track {
    background-color: #FFFFFF;
    border-radius: 14px;
    width: 100%;
    height: 100%;
}

.thumb {
    position: absolute;
    left: 3px;
    top: calc(50% - 6px);
    width: 12px;
    height: 12px;
    background-color: #CCCCCC;
    border-radius: 50%;
    transition: all .2s;
}
.checked .thumb {
    left: calc(100% - 12px - 3px);
    background-color: var(--primary-color);
}

</style>